import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Welcome } from 'components/common/Welcome/Welcome'
import styles from './AbilityWelcome.module.scss'
import { getRespondent, getGMA } from 'ducks/respondent'
import { toGmaQuizGuide } from 'ducks/router'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'
import { DeadlineHint } from 'components/quiz/Quiz/Quiz'
import EyeIcon from 'assets/icons/eye.svg'

// the GMA fields win over the respondent ones
const selectWelcome = state => ({ ...getRespondent(state), ...getGMA(state) })

const AbilityWelcome = () => {
  const {
    id: uuid,
    totalQuestions,
    secondsTotal,
    deadline,
    deadline_display,
    deadline_tz,
    past_deadline,
    language,
  } = useSelector(selectWelcome, shallowEqual)
  const dispatch = useDispatch()

  return (
    <Welcome
      description={
        <div className={styles.description}>
          <div className={styles.paragraph}>
            {t`The test consists of ${totalQuestions} questions of varying difficulty.`}{' '}
            <b>{t`We recommend that you take the test somewhere quiet and without distractions.`}</b>
          </div>
          <div className={styles.paragraph}>
            {t`Each question has 6 alternative answers and`}{' '}
            <b>{t`only one of them is correct`}</b>.{' '}
            {t`You may skip questions which you cannot answer. They will reappear again at the end.`}
          </div>
          <div className={styles.paragraph}>
            {t`By pressing “See an example” you will see an example of the questions the test consist of.`}
          </div>
          <DeadlineHint
            {...{
              deadline,
              deadline_display,
              deadline_tz,
              past_deadline,
              language,
            }}
          />
        </div>
      }
      totalQuestions={totalQuestions}
      time={`${Math.round(secondsTotal / 60)} ${t`minutes`}`}
      button={
        <BoldButton
          label={t`See an example`}
          icon={EyeIcon}
          isIconFirst
          onClick={() => dispatch(toGmaQuizGuide({ uuid }))}
        />
      }
    />
  )
}

export default AbilityWelcome
